import { Model } from 'vue-mc'
import store from '@/store'
import router from '@/router'

class BaseModel extends Model {
  boot () {
    this.API_BASE = process.env.VUE_APP_API_URL
    this.on('fetch, save, delete', this._onClearStore)
  }

  getDefaultHeaders () {
    const headers = {}
    const session = store && store.state && store.state.login
      ? store.state.login
      : null

    if (session) {
      headers.Authorization = `Bearer ${session.token}`
      if (store.state.currentRestaurant.data._id) headers.Restaurant = store.state.currentRestaurant.data._id
      if (store.state.currentProvider.data._id) headers.Provider = store.state.currentProvider.data._id
    }

    if (store.state.userProvider) {
      headers['userProvider'] = store.state.userProvider
    }

    return headers
  }

  async sendRequest (payload) {
    try {
      const response = await this.createRequest(payload).send()
      return response
    } catch (error) {
      throw new Error(error.response.response.data.message)
    }
  }

  _onClearStore (event) {
    const { error } = event
    if (error && error.response && error.response.response && error.response.response.status === 401) {
      store.dispatch('logout')
      router.push('/login')
    }
    return true
  }
}

export default BaseModel
